/**
 * Parse URL query parameters
 * @param url - The URL to parse (defaults to current window location)
 * @returns Object with query parameters
 */
export const parseUrlParams = (url?: string): Record<string, string> => {
  const urlToParse = url || window.location.href;
  const urlObj = new URL(urlToParse);
  const params: Record<string, string> = {};
  
  urlObj.searchParams.forEach((value, key) => {
    params[key] = value;
  });
  
  return params;
};

/**
 * Get token from URL query parameter
 * @param url - The URL to parse (defaults to current window location)
 * @returns The token value or null if not found
 */
export const getTokenFromUrl = (url?: string): string | null => {
  const params = parseUrlParams(url);
  return params.t || null;
};

/**
 * Validate if a token string is valid format
 * @param token - The token to validate
 * @returns boolean indicating if token is valid
 */
export const isValidToken = (token: string | null): token is string => {
  if (!token) return false;
  // Basic validation - check if it's a non-empty string
  // You can add more specific validation rules here if needed
  return token.trim().length > 0;
}; 